
import { repoHost } from '@/features/providers/lib/versions'

/**
 * Best-effort deep link to the VCS release page for one version (GitHub `/releases/tag/v{x}`,
 * GitLab `/-/releases/v{x}`). Null when there is no source_url or the host isn't a known VCS -
 * callers fall back to plain text. Assumes the conventional `v` tag prefix (true for the
 * registry's provider repos); a missing tag just lands on the repo's releases page 404, not ours.
 */
export function releaseUrl(sourceUrl: string | null, version: string): string | null {
  const host = repoHost(sourceUrl)
  if (!host || !sourceUrl) return null
  const base = sourceUrl.replace(/\/$/, '')
  const tag = encodeURIComponent(`v${version.replace(/^v/, '')}`)
  return host === 'github' ? `${base}/releases/tag/${tag}` : `${base}/-/releases/${tag}`
}

/** True iff `url` parses and is `https:` - the minimum bar for rendering scanner-supplied data
 *  (primary_url comes straight from Trivy's JSON meta with no server-side validation) as an
 *  `<a href>`. Unlike SourceLink's host allowlist, advisory URLs legitimately span many vendor
 *  hosts (avd.aquasec.com, osv.dev, pkg.go.dev, ...), so this only rules out non-navigable or
 *  dangerous schemes (javascript:, data:, vbscript:) rather than pinning specific hosts. */
export function isSafeHttpsUrl(url: string | null | undefined): url is string {
  if (!url) return false
  try {
    return new URL(url).protocol === 'https:'
  } catch {
    return false
  }
}
